var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61538 5.53846C5.32862 5.53846 5.09615 5.77093 5.09615 6.05769C5.09615 6.34446 5.32862 6.57692 5.61538 6.57692H8.38462C8.67138 6.57692 8.90385 6.34446 8.90385 6.05769C8.90385 5.77093 8.67138 5.53846 8.38462 5.53846H5.61538Z",
    fill: "#7043FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 1.90385C0.25 2.77531 0.835517 3.51001 1.63462 3.73603V10.2115C1.63462 10.7165 1.8352 11.2007 2.19224 11.5578C2.54928 11.9148 3.03353 12.1154 3.53846 12.1154H10.4615C10.9665 12.1154 11.4507 11.9148 11.8078 11.5578C12.1648 11.2007 12.3654 10.7165 12.3654 10.2115V3.73603C13.1645 3.51001 13.75 2.77531 13.75 1.90385C13.75 0.852381 12.8976 0 11.8462 0H2.15385C1.10238 0 0.25 0.852381 0.25 1.90385ZM2.15385 1.03846C1.67591 1.03846 1.28846 1.42591 1.28846 1.90385C1.28846 2.38178 1.67591 2.76923 2.15385 2.76923H11.8462C12.3241 2.76923 12.7115 2.38178 12.7115 1.90385C12.7115 1.42591 12.3241 1.03846 11.8462 1.03846H2.15385ZM11.3269 10.2115V3.80769H2.67308V10.2115C2.67308 10.4411 2.76425 10.6612 2.92654 10.8235C3.08883 10.9857 3.30895 11.0769 3.53846 11.0769H10.4615C10.6911 11.0769 10.9112 10.9857 11.0735 10.8235C11.2357 10.6612 11.3269 10.4411 11.3269 10.2115Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive_icon.8aae640ae9b351fe5ea0fa35aa84163f.svg";
export { ForwardRef as ReactComponent };